'use client'

import { CompactToggleable } from '~/components/component-library/Toggleable/components/CompactToggleable'
import { StandardToggleable } from '~/components/component-library/Toggleable/components/StandardToggleable'
import { ToggleableProps } from '~/components/component-library/Toggleable/types'

export type {
  ToggleableProps,
  ToggleableLayout,
  StandardToggleableProps,
  CompactToggleableProps,
} from '~/components/component-library/Toggleable/types'

export const Toggleable = (props: ToggleableProps) =>
  props.layout === 'compact' ? (
    <CompactToggleable {...props} />
  ) : (
    <StandardToggleable {...props} />
  )
